/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConfigItem } from '../models/ConfigItem';
import type { ConfigListResponse } from '../models/ConfigListResponse';
import type { ConfigUpdateRequest } from '../models/ConfigUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DefaultService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * モジュールのバージョンを返します。
     * @returns any Successful Response
     * @throws ApiError
     */
    public getVersion(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/version',
        });
    }
    /**
     * Health Check
     * ヘルスチェック
     * @returns any Successful Response
     * @throws ApiError
     */
    public healthCheckHealthGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/health',
        });
    }
    /**
     * Get Config
     * 設定を取得
     * @returns ConfigItem Successful Response
     * @throws ApiError
     */
    public getConfigConfigsConfigGroupConfigPathGet({
        configGroup,
        configPath,
    }: {
        /**
         * 設定グループ
         */
        configGroup: string,
        /**
         * 設定パス
         */
        configPath: string,
    }): CancelablePromise<ConfigItem> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/configs/{config_group}/{config_path}',
            path: {
                'config_group': configGroup,
                'config_path': configPath,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Config
     * 設定を更新
     * @returns ConfigItem Successful Response
     * @throws ApiError
     */
    public updateConfigConfigsConfigGroupConfigPathPut({
        configGroup,
        configPath,
        requestBody,
    }: {
        /**
         * 設定グループ
         */
        configGroup: string,
        /**
         * 設定パス
         */
        configPath: string,
        requestBody: ConfigUpdateRequest,
    }): CancelablePromise<ConfigItem> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/configs/{config_group}/{config_path}',
            path: {
                'config_group': configGroup,
                'config_path': configPath,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Configs
     * 設定一覧を取得
     * @returns ConfigListResponse Successful Response
     * @throws ApiError
     */
    public listConfigsConfigsConfigGroupGet({
        configGroup,
        prefix,
    }: {
        /**
         * 設定グループ
         */
        configGroup: string,
        prefix?: (string | null),
    }): CancelablePromise<ConfigListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/configs/{config_group}',
            path: {
                'config_group': configGroup,
            },
            query: {
                'prefix': prefix,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
